//import { createApi } from '@reduxjs/toolkit/dist/query'
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

const baseURI = 'https://tracker-server-lake.vercel.app'

export const apiSlice = createApi({
    baseQuery : fetchBaseQuery({baseUrl: baseURI}),
    
    endpoints: builder => ({
        getCategories: builder.query({
            query:()=>'/categories',
            providesTags:['categories']
        }),

        //get lables
        getLabels:builder.query({
             query : ()=>'/labels',          
             providesTags: ['transactions']
        }),
       
        //add transactions
        addTransaction:builder.mutation({
            query:(initial)=>({
                url:'/transactions',
                method:'POST',
                body: initial
            }),
            invalidatesTags:['transactions']
        }),

        //delete
        deleteTranstion:builder.mutation({
            query: recordid=>({
                url:'/transactions',
                method:'DELETE',
                body: recordid
            }),
            invalidatesTags:['transactions']
        })
    })
})

export default apiSlice